import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Route, Routes, useNavigate } from "react-router-dom";
import AddressSelection from "./Steps/AddressSelection";
import ConfirmCustomerDetails from "./Steps/ConfirmCustomerDetails";
import CustomerDetails from "./Steps/CustomerDetails";
import Outro from "./Steps/Outro";
import Welcome from "./Steps/Welcome";

export const RegistrationSteps = {
	Welcome: { Step: 0, Url: "Welcome" },
	AddressSelection: { Step: 1, Url: "SelectAddress" },
	CustomerDetails: { Step: 2, Url: "EnterDetails" },
	CustomerDetailsConfirmation: { Step: 3, Url: "ConfirmDetails" },
	Finish: { Step: 4, Url: "Finish" },
};

export default function Registration() {
	const [address, setAddress] = useState(null);
	const [details, setDetails] = useState(null);

	const navigate = useNavigate();

	function handleOnContinue(data, currentStep) {
		if (currentStep === RegistrationSteps.AddressSelection.Step) {
			setAddress(data);
		}

		if (currentStep === RegistrationSteps.CustomerDetails.Step) {
			setDetails(data);
		}

		const nextStep = Object.values(RegistrationSteps).find((step) => step.Step === currentStep + 1);
		if (nextStep) {
			navigate(nextStep.Url);
		}
	}

	useEffect(() => {
		navigate(RegistrationSteps.Welcome.Url);
	}, []);

	return (
		<Container className="d-flex justify-content-center h-100">
			<Routes>
				<Route path="Welcome" element={<Welcome onContinue={handleOnContinue} />} />
				<Route
					path="SelectAddress"
					element={<AddressSelection onContinue={handleOnContinue} address={address} />}
				/>
				<Route
					path="EnterDetails"
					element={<CustomerDetails onContinue={handleOnContinue} address={address} customer={details} />}
				/>
				<Route
					path="ConfirmDetails"
					element={<ConfirmCustomerDetails onContinue={handleOnContinue} details={details} address={address} />}
				/>
				<Route path="Finish" element={<Outro />} />
			</Routes>
		</Container>
	);
}
